import $ from 'jquery';

class Search {
    constructor() {
        this.openButton = $(".fa-search");
        this.openMenu = $(".fa-bars");
        this.closeButton = $("#close");
        this.searchBackground = $(".search-background");
        this.searchOverlay = $(".search-overlay");
        this.searchField = $("#search-term");
        this.resultsDiv = $("#search-overlay_results");
        this.events();
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
        this.currentURL = window.location.href;
        this.about = this.currentURL.replace(window.location.pathname, "/about");
        this.ministry = this.currentURL.replace(window.location.pathname, "/ministry");
        this.music = this.currentURL.replace(window.location.pathname, "/music");
        this.news = this.currentURL.replace(window.location.pathname, "/news");
        this.e_source = this.currentURL.replace(window.location.pathname, "/e-source");
    }

    // events
    events() {
        this.openButton.on("click", this.openOverlay.bind(this));
        this.openMenu.on("click", this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));
        this.searchField.on("keyup", this.typingLogic.bind(this));
    }

    // methods
    openOverlay() {
        this.searchBackground.addClass("search-overlay--active");
        this.searchOverlay.addClass("search-overlay--active");
        this.searchField.focus();
    }

    closeOverlay() {
        this.searchBackground.removeClass("search-overlay--active");
        this.searchOverlay.removeClass("search-overlay--active");
        this.searchField.val('');
        this.resultsDiv.html(`
            <ul class="nav_links">
                <li class="f-50-35"><a href="${this.about}">ABOUT</a></li>
                <li class="f-50-35"><a href="${this.ministry}">MINISTRY</a></li>
                <li class="f-50-35"><a href="${this.music}">MUSIC</a></li>
                <li class="f-50-35"><a href="${this.news}">NEWS</a></li>
                <li class="f-50-35"><a href="https://www.restore61.com/">SHOP</a></li>
                <li class="f-50-35"><a href="${this.e_source}">E-SOURCE</a></li>
            </ul>
        `);
    }

    typingLogic() {
        if (this.searchField.val() != this.previousValue) {
            clearTimeout(this.typingTimer);

            if (this.searchField.val()) {
                if (!this.isSpinnerVisible) {
                    this.resultsDiv.html('<div class="loader"></div>');
                    this.isSpinnerVisible = true;
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 2000);
            } else {
                this.resultsDiv.html(`
                    <ul class="nav_links">
                        <li class="f-50-35"><a href="${this.about}">ABOUT</a></li>
                        <li class="f-50-35"><a href="${this.ministry}">MINISTRY</a></li>
                        <li class="f-50-35"><a href="${this.music}">MUSIC</a></li>
                        <li class="f-50-35"><a href="${this.news}">NEWS</a></li>
                        <li class="f-50-35"><a href="https://www.restore61.com/">SHOP</a></li>
                        <li class="f-50-35"><a href="${this.e_source}">E-SOURCE</a></li>
                    </ul>
                `);
                this.isSpinnerVisible = false;
            }
        }
        this.previousValue = this.searchField.val();
    }

    getResults() {
        $.getJSON(i6tyoneData.root_url + "/wp-json/i6tyone/v1/search/?term=" + this.searchField.val(), results => {
            this.resultsDiv.html(`
                ${results.all.length ? '' : "<p>검색결과가 없습니다. 다른 키워드로 검색해보시거나, <br class='before-mobile'> 관련 정보가 없을 수 있습니다.</p>"}
                ${results.all.map(item => `
                <div class="img-div">
                    <a href="${item.permalink}"><img src="${item.thumbnail}" alt="thumbnail"></a>
                    <div>
                        <p class="lang-en">${item.postType}</p>
                        <p class="search-title">${item.title}</p>
                    </div>
                </div>`).join("")}
                <div class="empty-box"></div>
            `);
            this.isSpinnerVisible = false;
        });
    }
}

export default Search;